var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('StructureCompanyAddAndLinkWorkRoleModal',{ref:"addAndlinkWorkRoleModal"}),_c('EmployeeRolesLinkModal',{ref:"employeeRolesLink",attrs:{"showBtn":false}}),_c('DeleteModal',{ref:"deleteModal",attrs:{"showBtn":false}}),_c('div',{ref:"tree",staticClass:"tree",attrs:{"id":"tree"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }